import { memo } from 'react'
import classNames from 'classnames'
import injectSheet from 'react-jss'
import RevealText from '@/components/RevealText'
import RevealFadeIn from '@/components/RevealFadeIn'
import style from './style'

const ProductHero = ({
  classes,
  className,
  subtitle,
  title,
  visible,
}) => {
  return (
    <div
      className={classNames({
        [classes.root]: true,
        [className]: className,
      })}
    >
      <div className={classes.hero}>
        <div className={classes.wrapperTitle}>
          <RevealText
            tag="h1"
            value={title}
            visible={visible}
            enterDuration={1}
            exitDuration={0.8}
            enterDelay={0}
            exitDelay={0.2}
            lineHeight={1}
            once={false}
          />
          <RevealFadeIn
            visible={visible}
            enterDelay={0.2}
            exitDuration={0.8}
            className={classes.subtitle}
          >
            {subtitle}
          </RevealFadeIn>
        </div>
      </div>
    </div>
  )
}

export default injectSheet(style)(memo(ProductHero))
